import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../../_models/file-info-display-result-dto';
import { Utils } from 'cc-common';
const ɵ0 = () => Date, ɵ1 = () => Date, ɵ2 = () => FileInfoDisplayResultDto;
export class VendorContractResultDto {
    get autoRenewDisplayText() {
        return Utils.notNullOrEmpty(this.autoRenew) ? this.autoRenew : null;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Date)
], VendorContractResultDto.prototype, "effectiveDate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], VendorContractResultDto.prototype, "endDate", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", FileInfoDisplayResultDto)
], VendorContractResultDto.prototype, "documents", void 0);
export { ɵ0, ɵ1, ɵ2 };
